import { render } from "./edit.vue?vue&type=template&id=4a450208"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"

import exportComponent from "D:\\消防\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/branch/industry/edit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4a450208"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4a450208', __exports__)) {
    console.log('reload')
    api.reload('4a450208', __exports__)
  }
  
  module.hot.accept("./edit.vue?vue&type=template&id=4a450208", () => {
    console.log('re-render')
    api.rerender('4a450208', render)
  })

}


export default __exports__